export default {
  data() {
    return {
      dynamicPageSize: 10,
      hasMeasuredPageSize: false,
    };
  },
  computed: {
    minTableRows() {
      return 4;
    },
  },
  methods: {
    syncTablePageSize(refetch) {
      if (this.hasMeasuredPageSize) return;
      this.$nextTick(() => {
        if (this.hasMeasuredPageSize) return;
        const root = this.$el;
        if (!root || !root.querySelector) return;

        const headEl = root.querySelector('thead');
        const rowEl = root.querySelector('tbody tr');
        if (!headEl || !rowEl) return;

        const rowHeight =
          Math.round(rowEl.getBoundingClientRect().height) || 52;
        const rowsTop = headEl.getBoundingClientRect().bottom;
        const RESERVE_BELOW = 80;
        const available = window.innerHeight - rowsTop - RESERVE_BELOW;
        const fit = Math.max(
          this.minTableRows,
          Math.floor(available / rowHeight)
        );

        this.hasMeasuredPageSize = true;
        if (fit !== this.dynamicPageSize) {
          this.dynamicPageSize = fit;
          if (typeof refetch === 'function') refetch(fit);
        }
      });
    },
  },
};
